<template>
  <page-outline :title="$t('Homepage.transactionstathistory')">
    <template slot="pageContent">
  <!-- <f7-page id="inbox"
    class="page-on-center rowBackgroundHomepage"
    data-page="inbox-page"
    :pull-to-refresh="isSmartphoneOS" @ptr:refresh="onRefresh(false)"
    infinite-scroll @infinite="onInfinite"> -->

    <!-- <div class="layoutTop"></div> -->
      <div class="listPage" style="overflow:hidden;">
        <b-row>
          <b-col md="12">
            <spinner v-if="activateSpinner"></spinner>
            <div v-else style="overflow-x:auto;">
              <!-- <f7-list> -->
                <!-- Affichage titre et messages filter -->
                <!-- <f7-list-item class="filterTitle"
                  :title="listTitle" style="font-size:36px;color:#0377b5;" id="filter-item">
                  <i class="icon fa fa-filtershowSmallScreenOnly mousePointer"
                    @click="$bus.emit('right-panel-open', serviceId)" slot="content">
                  </i>
                  <div style="display:flex;position:absolute;width:300px;" slot="content"></div>
                </f7-list-item>
              </f7-list> -->
              <f7-list>
                <f7-list-item :class="additionalClass">
                  <b-row class="justify-content-start mb-4">
                    <!-- Left section filtre -->
                    <b-col cols="3" class="showLargeScreenOnly">
                      <b-button class="btn btnFilter"
                        @click="displayFilter = !displayFilter">
                        <i v-if="displayFilter" class="fa-light fa-minus" style="font-size: 14px"></i>
                        <i v-else class="fa-light fa-plus" style="font-size: 14px"></i>
                        <!-- {{ displayFilter ? $t('filter.hide_fltr') : $t('filter.slct_fltr') }} -->
                      </b-button>
                    </b-col>
                    <b-col cols="3" class="showLargeScreenOnly">
                      <b-button class="btn btnFilter"
                        @click="refreshInbox()">
                        <i class="fa-light fa-rotate-right" style="font-size: 14px"></i>
                        <!-- <span class="fab-label">{{ $t('common.rfrsh') }}</span> -->
                      </b-button>
                    </b-col>
                    <!-- Right section filtre -->
                    <b-col>
                      <b-button class="btn btnFilter_2"
                        @click="$emit('extractCSV')">
                        <i class="fa-light fa-upload" style="font-size: 14px"></i>
                        <span class="fab-label">{{ $t('common.extract_list') }}</span>
                      </b-button>
                    </b-col>
                    <!-- TLV 15/01/2021 - Button for showing the filter on small screens more clearly -->
                    <!-- <b-col cols="12" class="showSmallScreenOnly">
                      <f7-button round class="statusButton searchFilterButton"
                        @click="$bus.emit('right-panel-open', serviceId)">
                        {{ $t('filter.slct_fltr') }}
                      </f7-button>
                    </b-col>
                    <b-col cols="5" offset="7" class="d-flex flex-row-reverse showLargeScreenOnly" v-if="displayFilter" style="margin-top:5px;"> -->
                      <!-- Attention : les boutons s'affichent de droite à gauche -->
                      <!-- <f7-button round class="statusButton searchFilterButton"
                        :disabled="!hasDefaultFilter"
                        @click="deleteFilter">
                        {{ $t('filter.cln_fltr') }}
                      </f7-button>
                      <f7-button round class="statusButton searchFilterButton"
                        :disabled="!hasInputFilter"
                        @click="saveDefaultFilter">
                        {{ $t('filter.sv_fltr') }}
                      </f7-button>
                    </b-col> -->
                  </b-row>
                </f7-list-item>

                <!-- Sélection des valeurs de Filtre -->
                <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}"
                  class="showLargeScreenOnly">
                  <b-row style="min-width:100%;">
                    <b-col class="d-flex flex-row">
                      <!-- Filtre date de début -->
                      <div class="filter-item" v-if="showFilterDateBegin()">
                        <span class="filter-item-title">
                          {{ $t('common.date_start_label') }}</span>
                        <span class="filter-item-content">
                          <input v-model="start_date"
                            type="date"
                            :class="{'filter-item-input': true, 'filter-item-input-complete': start_date}"
                            :placeholder="$t('common.slct_date')"
                            style="font-size:var(--fontSize); color: #969696;">
                        </span>
                      </div>

                      <!-- Filtre date de fin -->
                      <div class="filter-item" v-if="showFilterDateEnd()">
                        <span class="filter-item-title">
                          {{ $t('common.date_end_label') }}
                        </span>
                        <span class="filter-item-content">
                          <input v-model="end_date"
                            type="date"
                            :class="{'filter-item-input': true, 'filter-item-input-complete': end_date}"
                            :placeholder="$t('common.slct_date')"
                            style="font-size:var(--fontSize); color: #969696;">
                        </span>
                      </div>
                      <!-- Filtre Type -->
                      <div class="filter-item">
                        <span class="filter-item-title">{{ $t('administration.type') }}</span>
                        <span class="filter-item-content d-flex">
                          <select id="sel4"
                            v-model="type"
                            style="cursor:pointer;font-size:14px;height:auto;z-index:2;color: #969696">
                            <option v-for="result in type_list" :key="result"
                                :value="result">
                                {{ $t( result) }}
                            </option>
                          </select>
                          <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"
                            style="cursor:pointer;margin-left:-20px;z-index:1;">
                          </i>
                        </span>
                      </div>
                      <!-- Filtre Affichage -->
                      <div class="filter-item">
                        <span class="filter-item-title">{{ $t('administration.view') }}</span>
                        <span class="filter-item-content d-flex">
                          <select id="sel4"
                            v-model="display_by"
                            style="cursor:pointer;font-size:14px;height:auto;z-index:2;color: #969696">
                            <option v-for="result in display_by_list" :key="result"
                                :value="result">
                                {{ $t( result) }}
                            </option>
                          </select>
                          <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"
                            style="cursor:pointer;margin-left:-20px;z-index:1;">
                          </i>
                        </span>
                      </div>
                    </b-col>
                  <!-- Bouton Effacer et Appliquer -->
                  <b-col cols="3" class="d-flex flex-row-reverse mt-4">
                    <b-button class="btn" size="sm"
                      @click="applyFilter(modeFilter)">
                      {{ $t('filter.fltr') }}
                    </b-button>
                    <b-button class="btn mr-2" size="sm"
                      @click="clearFilterFields"
                      :disabled="!hasInputFilter">
                      {{ $t('filter.clr_fltr_field') }}
                    </b-button>
                  </b-col>
                </b-row>
              </f7-list-item>
              </f7-list>
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- <canvas id="myChart" :chartData="chartData" :options="options" width="400" height="400"></canvas> -->
      <div v-if="check_graph === true" >
        <div class="center-div" style="width:500px; height:500px">
          <chart :chartData="chartData" :options="options"></chart>
        </div>
        <br>
      </div>
  <!-- </f7-page> -->
    </template>
  </page-outline>
</template>

<script>
import {statusLabel} from '@/helpers/labels'
// import moment from 'moment'
// import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
// import {errorMessageAlert} from '@/helpers/alert'
// import {loadPage} from '@/helpers/routing'
// import graph from '@/pages/statistics/components/GraphTransactions.vue'
// import { Bar } from 'vue-chartjs'
import * as R from 'ramda'
// import {Chart, mixins} from 'chart.js'
import Chart from '@/pages/statistics/components/graphiques/BarChart.vue'
import PageOutline from '@/components/common/PageOutline.vue'
// import MessagesFilter from '@/components/common/Filter'

export default {
  name: 'TransactionStatHistory',
  components: {
    // 'cm-pagination': Pagination,
    'spinner': Spinner,
    // Bar
    'chart': Chart,
    'page-outline': PageOutline
    // 'cm-messages-filter': MessagesFilter
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  data () {
    return {
      start_date: '',
      end_date: '',
      type: '',
      display_by: '',
      type_list: ['', 'status', 'creditor_bic', 'debtor_bic'],
      display_by_list: ['', 'total', 'month', 'day'],
      activateSpinner: false,
      filter: {},
      ListTransactions: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: true,
      hasDefaultFilter: false,
      check_graph: false,
      chartData: {
          labels: [],
          datasets: []
      },
      options: {
        responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        }
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return this.$t('Webheader.transactionstathistory')
    },
    hasInputFilter () {
      if (
        this.start_date !== '' ||
        this.end_date !== '' ||
        this.type !== '' ||
        this.display_by !== '') {
        return true
      }
      return false
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Statistiques Transactions',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', () => {
      // this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    // this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    let defaultFilter = this.$engine.transactionstathistory.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)
    // Command "clear filter fields" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-clear-filter-fields', () => {
      this.clearFilterFields()
    })

    // this.onRefresh()
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    let defaultFilter = this.$engine.transactionstathistory.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.transactionstathistory.cleanFilterCondition()
  },
  methods: {
    makeList (tab) {
      this.ListTransactions = tab
    },
    createChart () {
      if (this.display_by === 'total' || this.display_by === '') {
        this.makeChartDataTotal(this.ListTransactions)
      } else if (this.type === 'status' || this.type === '') {
        this.makeChartDataStat(this.ListTransactions)
      } else {
        this.makeChartData(this.ListTransactions)
      }
      this.check_graph = true
    },
    makeChartDataTotal (rawData) {
      this.chartData.labels.push('total')
      let transactionKeys = R.keys(rawData.total)
      for (let key of transactionKeys) {
        let keys = R.keys(rawData.total[key])
        for (let el of keys) {
          if (key === 'status') {
            this.chartData.datasets.push({data: [rawData.total[key][el]], label: statusLabel(this.$i18n, el, '0'), backgroundColor: [this.createBackground()]})
          } else {
            this.chartData.datasets.push({data: [rawData.total[key][el]], label: el, backgroundColor: [this.createBackground()]})
          }
        }
      }
    },
    makeChartDataStat (rawData) {
      let type = R.keys(rawData.status)
      for (let t of type) {
        for (let val = 0; val < rawData.status[t].length; val++) {
          let transactionKeys = R.keys(rawData.status[t][val])
          for (let key of transactionKeys) {
            this.chartData.labels.push(key)
            let keys = R.keys(rawData.status[t][val][key])
            if (this.chartData.labels.length > 1) {
              for (let it of keys) {
                this.addChartstat(it, rawData.status[t][val][key])
              }
            } else {
              for (let el of keys) {
                this.chartData.datasets.push({data: [rawData.status[t][val][key][el]], label: statusLabel(this.$i18n, el, '0'), backgroundColor: [this.createBackground()]})
              }
            }
          }
        }
      }
    },
    makeChartData (rawData) {
      let type = R.keys(rawData)
      for (let t of type) {
        for (let val = 0; val < rawData[t].length; val++) {
          let transactionKeys = R.keys(rawData[t][val])
          for (let key of transactionKeys) {
            this.chartData.labels.push(key)
            let keys = R.keys(rawData[t][val][key])
            if (this.chartData.labels.length > 1) {
              for (let it of keys) {
                this.addChart(it, rawData[t][val][key])
              }
            } else {
              for (let el of keys) {
                this.chartData.datasets.push({data: [rawData[t][val][key][el]], label: el, backgroundColor: [this.createBackground()]})
              }
            }
          }
        }
      }
    },
    addChartstat (el, tab) {
      let found = 0;
      let len = this.chartData.datasets[0].data.length
      for (let i = 0; i < this.chartData.datasets.length; i++) {
        if (statusLabel(this.$i18n, el, '0') === this.chartData.datasets[i].label) {
          found = 1
          this.chartData.datasets[i].data.push(tab[el])
        } else {
          this.chartData.datasets[i].data.push("0")
          // this.chartData.datasets[i].backgroundColor.push(this.createBackground())
        }
        this.chartData.datasets[i].backgroundColor.push(this.chartData.datasets[i].backgroundColor[this.chartData.datasets[i].backgroundColor.length - 1])
      }
      if (found === 0) {
        this.chartData.datasets.push({data: new Array(len).fill("0"), label: statusLabel(this.$i18n, el, '0'), backgroundColor: new Array(len).fill('rgba(0, 0, 0, 1)')})
        this.chartData.datasets[this.chartData.datasets.length - 1].data.push(tab[el])
        this.chartData.datasets[this.chartData.datasets.length - 1].backgroundColor.push(this.createBackground())
      }
    },
    addChart (el, tab) {
      let found = 0;
      let len = this.chartData.datasets[0].data.length
      for (let i = 0; i < this.chartData.datasets.length; i++) {
        if (el === this.chartData.datasets[i].label) {
          found = 1
          this.chartData.datasets[i].data.push(tab[el])
        } else {
          this.chartData.datasets[i].data.push(0)
          // this.chartData.datasets[i].backgroundColor.push(this.createBackground())
        }
        this.chartData.datasets[i].backgroundColor.push(this.chartData.datasets[i].backgroundColor[this.chartData.datasets[i].backgroundColor.length - 1])
      }
      if (found === 0) {
        this.chartData.datasets.push({data: new Array(len).fill("0"), label: el, backgroundColor: new Array(len).fill(this.createBackground())}) // à changer
        this.chartData.datasets[this.chartData.datasets.length - 1].data.push(tab[el])
        this.chartData.datasets[this.chartData.datasets.length - 1].backgroundColor.push(this.createBackground())
      }
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * max)
    },
    createBackground () {
      let str = 'rgba(' + this.getRandomInt(255) + ', ' + this.getRandomInt(255) + ', ' + this.getRandomInt(255) + ', 1)'
      return str
    },
    applyFilter (filterConditions = {}) {
      this.chartData.labels = []
      this.chartData.datasets = []
      this.check_graph = false
      /* let defaultFilter = this.$engine.transactionstathistory.getDefaultFilter()
      this.filterTypeGet = 'list'
      this.setDefaultFilter(defaultFilter) */

      this.$engine.transactionstathistory.cleanFilterCondition()
      this.$engine.transactionstathistory.start_date = this.start_date
      this.$engine.transactionstathistory.end_date = this.end_date
      this.$engine.transactionstathistory.type = this.type
      this.$engine.transactionstathistory.display_by = this.display_by


      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.activateSpinner = true
      this.filter = {
        start_date: this.start_date,
        end_date: this.end_date,
        type: this.type,
        display_by: this.display_by
      }

      this.$engine.transactionstathistory.getTransactionStatHistory(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        this.filter
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResults = resp.data.TransactionStatHistory.length
        requests = resp.data.TransactionStatHistory
        this.makeList(requests)
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
        this.createChart()
      })
      .catch(() => {
        if (this.start_date === '' || this.end_date === '') {
          let that = this
          this.check_graph = false
          that.$f7.modal({
            title: this.$i18n.t('administration.select_date'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
        }
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.start_date = ''
      this.end_date = ''
      this.type = ''
      this.display_by = ''
      this.chartData = {
          labels: [],
          datasets: []
      }
    },
    deleteFilter () {
      this.filter = {
        start_date: '',
        end_date: '',
        type: '',
        display_by: ''
      }
      this.chartData.labels = []
      this.chartData.datasets = []
      this.check_graph = false
      this.$engine.transactionstathistory.saveDefaultFilter(this.filter)
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: this.$i18n.t('administration.del_filter'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    saveDefaultFilter () {
      let defaultFilter = {
        start_date: this.start_date,
        end_date: this.end_date,
        type: this.type,
        display_by: this.display_by
      }
      this.$engine.transactionstathistory.saveDefaultFilter(defaultFilter)

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }
      let that = this
      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        this[property] = defaultFilter[property]
        if (defaultFilter[property]) {
          this.hasDefaultFilter = true
        }
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    showFilterDateBegin () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterDateEnd () {
      return !(this.filterType === 'list' && this.serviceId === '8')
    },
    /* showFilterEndToEndId () {
      return this.isHistory
    },
    showFilterTypeAction () {
      return this.isHistory
    },
    showFilterUser () {
      return this.isHistory
    },
    showStatus (status) {
      return status.services.includes(this.$engine.user.currentService.id) &&
        status.filterName === this.filterTypeGet
    }, */
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    /* exportTransactionStatHistory () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Status Historique' + ';' +
        'Date de création' + ';' +
        'Bic créditeur' + ';' +
        'Bic débiteur' + ';' +
        'Date de création payement' + ';' +
        'end_to_end_id' + ';' +
        'Status payement' + '\r\n'
      let lines = ''
      for (var i = 0; i < this.ListTransactions.length; i++) {
        let result = this.ListTransactions[i]
        lines += result.payment_history.status + ';' +
                 result.payment_history.creation_date + ';' +
                 result.payment.creditor_bic + ';' +
                 result.payment.debtor_bic + ';' +
                 result.payment.creation_date + ';' +
                 result.payment.end_to_end_id + ';' +
                 result.payment.status + '\r\n'
      }
      let data = firstLine + lines
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'transactionstathistory_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }, */
    onClear () {
      this.filter = {
        start_date: '',
        end_date:'',
        type: '',
        display_by: ''
      }
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        /* this.$engine.transactionstathistory.getTransactionStatHistory(
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          this.filter
        ).then(resp => {
          let requests = {}
          that.requestsNumber = resp.data.TransactionStatHistory.length

          requests = resp.data.TransactionStatHistory
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.ListTransactions.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        }) */
      }
    },
    onRefresh () {
      // const that = this
      this.$bus.$emit('change-mobile-header', {
        backLink: false,
        navbarInnerStyle: 'justify-content:start;',
        navTitle: 'Statistiques Transactions',
        returnUrl: ''
      })
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 13
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      this.$bus.$off('refresh-cache-contacts')

      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.$bus.$off('direct-inbox-filtered')
      this.$bus.$on('direct-inbox-filtered', () => {

        that.pageCounter = 0
      })

      this.$f7.initPullToRefresh()
      this.pageCounter = 0
      this.filterTypeGet = this.filterType
      this.$bus.emit('right-panel-set-feature', 'filter-messages')

      this.filter = this.$engine.transactionstathistory.getDefaultFilter()

      this.$engine.transactionstathistory.getTransactionStatHistory(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        this.filter
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.TransactionStatHistory) {
          requests = resp.data.TransactionStatHistory
          this.makeList(requests)
          this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      }).catch(() => {
        if (this.start_date === '' || this.end_date === '') {
          let that = this
          that.$f7.modal({
            title: this.$i18n.t('administration.select_date'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
        }
      })
    },
    onSearch (query) {
      this.filter = query
    },
    /* refreshInbox () {
      this.onRefresh()
    }, */
    /* reOrderBy (column) {
      if (this.sortField === column) {
        console.log('column :', column)
        console.log('sortField :', this.sortField)
        console.log('sortDirection:', this.sortDirection)
        // just switch order
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        // new column + default order
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      if (this.$engine.history.getDefaultFilter()) {
        filterConditions = this.$engine.history.getDefaultFilter()
      } else {
        filterConditions = this.$engine.history.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.transactionhistorylist.getTransactionHistoryLists(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResults = resp.data.TransactionHistoryList.length
        resp.data.TransactionHistoryList.forEach(item => {
          // item.dateAction = moment(item.dateAction).format('DD/MM/yyyy HH:mm:ss')
          // item.typeAction = this.$t('history.' + item.typeAction)
        })
        requests = resp.data.TransactionHistoryList
        this.updateInbox(requests, false)
        this.$f7.pullToRefreshDone()
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this)
      })
    }, */
    updateInbox (requests, noAttach = false) {
      this.ListTransactions = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    }
  }
}
</script>

<style scoped>
.center-div {
     margin: 0 auto;
     width: 100px;
}
.sellersResults {
  border: 1px solid silver;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0 0 15px 15px;
  overflow: hidden;
  width: 100%;
}

.sellersResults th {
  background-color: black;
  border: 1px solid silver;
  color: white;
  font-weight: normal;
  height: 40px;
}

.sellersResults tbody tr td {
  border-top: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: white;
}

.sellersResults tbody tr td,.sellersResults thead th {
  text-align: center;
}


::-webkit-input-placeholder {
  color: #A7A7A7;
}


#status-chevron {
  font-size: inherit;
  line-height: inherit;
  color:inherit;
}

.row {
  margin: 0;
}
</style>
